import PublishedDetail from '@/shared/publish/MyPublications/PublishedDetail/'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/'
)({
  component: RouteComponent,
  loader: ({ params }) => {
    return {
      useStr: params.use,
      pageStr: params.page,
      caseStr: params.case,
      tabStr: params.tab,
    }
  },
})

function RouteComponent() {
  const { useStr, pageStr, caseStr, tabStr } = Route.useLoaderData()
  return (
    <PublishedDetail
      useStr={useStr}
      pageStr={pageStr}
      caseStr={caseStr}
      tabStr={tabStr}
    />
  )
}
